import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link ShowSaveDraftChangesBarCommand}
 */
export type ShowSaveDraftChangesBarCommandProperties = CommandProperties;

/**
 * Command to show the save draft changes bar in the native embed experience.
 *
 * This command displays a notification bar that alerts users to unsaved changes
 * and provides options to save or discard their modifications, appearing in
 * the host application's UI rather than within the database iframe.
 */
export const ShowSaveDraftChangesBarCommand = createCommand<
  ShowSaveDraftChangesBarCommandProperties,
  void
>('show-save-draft-changes-bar-command');
